import { Action } from '@ngrx/store';
import { GameDayModel } from '../../models/gameday-model';

export enum ChartActionTypes {
  HoverRecentOrder = '[Chart] Hover recent order',
  SelectTranche = '[Chart] Select tranche',
  CombineTranche = '[Chart] Combine tranche',
  CombineAllTranches = '[Chart] Combine all tranches',
  Reset = '[Chart] Reset'
}

export class SelectTranche implements Action {
  public readonly type: string = ChartActionTypes.SelectTranche;

  constructor(public payload: string) {}
}

export class CombineTranche implements Action {
  public readonly type: string = ChartActionTypes.CombineTranche;
  public readonly location: boolean = true; // ToDo: Not sure if we need

  constructor(public payload: string[]) {}
}

export class CombineAllTranches implements Action {
  public readonly type: string = ChartActionTypes.CombineAllTranches;

  constructor(public payload: boolean) {}
}

export class HoverRecentOrder implements Action {
  public readonly type: string = ChartActionTypes.HoverRecentOrder;

  constructor(public payload?: GameDayModel.Order) {}
}

export class Reset implements Action {
  public readonly type: string = ChartActionTypes.Reset;
  public readonly payload = undefined;
}

export type ChartActionUnion =
  | SelectTranche
  | CombineTranche
  | CombineAllTranches
  | HoverRecentOrder
  | Reset;
